import cn from "classnames";
import PropTypes from "prop-types";
import React from "react";
import {
    IconWrap,
    ItemAnchor,
    ItemWrap,
    Marker,
    Title,
    TitleInner,
    TitleWrap,
} from "./style";

export const NumberedListItem = ({ path, number, children, className }) => {
    let numb = number < 10 ? `0${number}` : number;
    return (
        <ItemWrap className={cn(className, "numbered-list-item")}>
            <ItemAnchor path={path}>
                <TitleWrap>
                    <TitleInner>
                        {number && <Marker>{numb}</Marker>}
                        <Title>{children}</Title>
                        <IconWrap>
                            <i className="icon far fa-long-arrow-right"></i>
                        </IconWrap>
                    </TitleInner>
                </TitleWrap>
            </ItemAnchor>
        </ItemWrap>
    );
};

NumberedListItem.propTypes = {
    path: PropTypes.string,
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
};

NumberedListItem.defautProps = {
    path: "/",
};
